import {   Link } from "react-router-dom"
import {  Button as SVAButton, Result} from 'antd';

import GlassTerrain from '../terrain/GlassTerrain'
import CardTerrain from '../terrain/CardTerrain'

import SVFlyWizard from './SVFlyWizard'
import FlyTerrainLocation from '../terrain/FlyTerrainLocation'
import AmbPriceSummaryView from '../amb/AmbPriceSummaryView'

import TerrainAmenitiesTabletReview from '../terrain/TerrainAmenitiesTabletReview'
import { Icon,Tag } from 'antd';
import AmbOfferItnReview from '../amb/AmbOfferItnReview'

import AmbAmenitiesTabletReview from '../amb/AmbAmenitiesTabletReview'
import AmbTravellersDetailView from '../amb/AmbTravellersDetailView'


import {SV_SOJ_LOCALSTORAGE_TYPE} from '../../constants'
import '../../css/svr_review_react.css'

//import AddOnFormBusCom from './AddonServicesFormBusCom'
 

const React = require('react')
const _ = require('lodash')
//import { useLocation } from 'react-router-dom'

//import { useLocation } from 'react-redux'

const HeartSvg = () => (
    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
      <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z" />
    </svg>
  );


const HeartIcon = props => <Icon component={HeartSvg} {...props} />;

class FlyFinalStepPaymentReviewContainer extends React.Component {

    constructor(props) {
        super(props)
        let me = this
        this.getAppDetails = this.getAppDetails.bind(this)
        this.getAppDetailsMyReservation = this.getAppDetailsMyReservation.bind(this)
        


        
        this.title = 'Final Step - Review Payment'
        this.getHotelAmenityList = this.getHotelAmenityList.bind(me)
        this.getChildContainers = this.getChildContainers.bind(me)
        this.getEconomyCabinClassContainer = this.getEconomyCabinClassContainer.bind(me)
        this.getEconomyCabinClassContainer_amb = this.getEconomyCabinClassContainer_amb.bind(me)
        this.getBookdetContainer = this.getBookdetContainer.bind(me)
        this.getPricedetContainer = this.getPricedetContainer.bind(me)
        this.getPricedetContainer_amb = this.getPricedetContainer_amb.bind(me)

        this.getAllLegsRightContainer = this.getAllLegsRightContainer.bind(me)
        this.getAllLegsRightContainer_amb = this.getAllLegsRightContainer_amb.bind(me)
        this.getAddonRightContainer = this.getAddonRightContainer.bind(me)
        this.getSpecailRightContainer = this.getSpecailRightContainer.bind(me)
        this.getArrivalRightContainer = this.getArrivalRightContainer.bind(me)
        this.getCardRightContainers = this.getCardRightContainers.bind(me)
        this.svsubmitparent = this.svsubmitparent.bind(me)
        this.svguestsaveparent = this.svguestsaveparent.bind(me)
        this.svguestsavesvdocparent = this.svguestsavesvdocparent.bind(me)
        this.svguestsavesvtocparent = this.svguestsavesvtocparent.bind(me)
        
        this.svrcsubmitparent = this.svrcsubmitparent.bind(me)


        
     
      
    }
    svrcsubmitparent(bookValues){
        let me = this
      console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv step2 book ajax  callback**********parent')
      console.log(bookValues)
   // const travellerOb = {my_data_traveller:bookValues }
  //  return this.props.flySaveTravellerReviewSuccess(travellerOb)

    }
    svguestsaveparent(bookValues){
        let me = this
      console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv step2 book ajax  callback**********parent')
      console.log(bookValues)
    const travellerOb = {my_data_traveller:bookValues }
    return this.props.flySaveTravellerReviewSuccess(travellerOb)

    }
    svguestsavesvtocparent(bookValues){
        let me = this
      console.log('^^^^^^^^^^^^^^^^^SVSVSVSVSV^^^^^^^^^^^^sv No8 svj21 my_data_svtoc  SVFLyWizard - FlypaymenttocumentFormBusCom with formdata for stroting in rreducer callback**********parent')
      console.log(bookValues)
      console.log('^^^^^^^^^^^^^^^^^SVSVSVSVSV^^^^^^^^^^^^sv No8 svj21 my_data_svtoc  SVFLyWizard - FlypaymenttocumentFormBusCom with formdata for stroting in rreducer callback**********parent')
     
    const svdocOb = {my_data_svtoc:bookValues }
    return this.props.flySaveTocumentReviewSuccess(svdocOb)

    }
    svguestsavesvdocparent(bookValues){
        let me = this
      console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv Nov4  step2 book ajax  callback**********parent')
      console.log(bookValues)
    const svdocOb = {my_data_svdoc:bookValues }
    return this.props.flySaveDocumentReviewSuccess(svdocOb)

    }
    svsubmitparentWorkingSV(values){
        let me = this
      console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv submit callback**********parent')
      console.log(values)
      ///essearch/spaceBookNow
      //get props.state 
      console.log(this.props.my_data_traveller)
      let comCardAndTraveller = {
        card : values,
        traveller: null
      }  
      if(this.props.my_data_traveller){
        comCardAndTraveller['traveller'] = this.props.my_data_traveller
      }
      const { cookies } = this.props;
      const svtv = cookies.get('svt')
     return this.props.flypriceAndTexNowSecure(comCardAndTraveller,svtv)
  
    }
  
    
    getAppDetailsMyReservation(paramQSpaceId, svcustProfile){
        console.log('caall MARCH31 getAppDetailsMyReservation1 ')
        const { cookies } = this.props;
        const svtv = cookies.get('svt')
        /*svdec3 dtart*/
        
        let flyob = paramQSpaceId
        console.log('caall MARCH31 getAppDetailsMyReservation', paramQSpaceId,svcustProfile)
       
        flyob.svtv = svtv
         /*svdec3 dtart*/
        this.props.flyLoadReviewNowMyReservationForCustId(paramQSpaceId, svcustProfile)
        //this.props.sojDetailsAndImagesSV("mancreek") 
        /*this.props.getSojournDetails("mancreek") */
       
    }
    getAppDetails(paramOb){
        console.log('caall MARCH31getAppDetails', paramOb)
        
        const { cookies } = this.props;
        let expsessid_svt_s =  cookies.get('svabodeclientguest')
        /*svdec3 dtart*/
        let flyob = paramOb
        flyob.svtv = expsessid_svt_s
        console.log('caall MARCH31 getAppDetails', flyob)
       
        this.props.flyLoadReviewNow(paramOb)
        //this.props.sojDetailsAndImagesSV("mancreek") 
        /*this.props.getSojournDetails("mancreek") */
       
    }
    getAppDetailsOrgDec3(paramOb){
        this.props.flyLoadReviewNow(paramOb)
        //this.props.sojDetailsAndImagesSV("mancreek") 
        /*this.props.getSojournDetails("mancreek") */
       
    }
    getAppDetailsSVGood_org(paramQSpaceId){
        this.props.flyLoadReviewNow(paramQSpaceId)
        //this.props.sojDetailsAndImagesSV("mancreek") 
        /*this.props.getSojournDetails("mancreek") */
       
    }

    svsubmitparent(values){
        let me = this
      console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv submit callback svflyreview**********parent')
      console.log(values)
      ///essearch/spaceBookNow
      //get props.state 
      console.log(this.props.my_data_traveller)
      console.log(this.props.my_data_svtoc)
      console.log(this.props.my_data_svdoc)
      console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv submit callback svflyrevie needs offer w**********parent', this.props.my_data_flyreview)
      
      console.log(this.props.my_data_flyreview)

      let {offer} = this.props.my_data_flyreview
      if(!offer){
          offer = {
              "type": "flight-offer",
              "id": "1",
              "source": "GDS",
              "instantTicketingRequired": false,
              "nonHomogeneous": false,
              "paymentCardRequired": false,
              "lastTicketingDate": "2024-10-25",
              "itineraries": [
                  {
                      "segments": [
                          {
                              "departure": {
                                  "iataCode": "EWR",
                                  "terminal": "B",
                                  "at": "2024-11-01T19:29:00"
                              },
                              "arrival": {
                                  "iataCode": "SFO",
                                  "terminal": "1",
                                  "at": "2024-11-01T22:53:00"
                              },
                              "carrierCode": "AS",
                              "number": "295",
                              "aircraft": {
                                  "code": "73H"
                              },
                              "operating": {
                                  "carrierCode": "AS"
                              },
                              "duration": "PT6H24M",
                              "id": "1",
                              "numberOfStops": 0,
                              "co2Emissions": [
                                  {
                                      "weight": 612,
                                      "weightUnit": "KG",
                                      "cabin": "BUSINESS"
                                  }
                              ]
                          }
                      ]
                  }
              ],
              "price": {
                  "currency": "USD",
                  "total": "788.07",
                  "base": "719.07",
                  "fees": [
                      {
                          "amount": "0.00",
                          "type": "SUPPLIER"
                      },
                      {
                          "amount": "0.00",
                          "type": "TICKETING"
                      },
                      {
                          "amount": "0.00",
                          "type": "FORM_OF_PAYMENT"
                      }
                  ],
                  "grandTotal": "788.07",
                  "billingCurrency": "USD"
              },
              "pricingOptions": {
                  "fareType": [
                      "PUBLISHED"
                  ],
                  "includedCheckedBagsOnly": true
              },
              "validatingAirlineCodes": [
                  "AS"
              ],
              "travelerPricings": [
                  {
                      "travelerId": "1",
                      "fareOption": "STANDARD",
                      "travelerType": "ADULT",
                      "price": {
                          "currency": "USD",
                          "total": "788.07",
                          "base": "719.07",
                          "taxes": [
                              {
                                  "amount": "5.00",
                                  "code": "ZP"
                              },
                              {
                                  "amount": "5.60",
                                  "code": "AY"
                              },
                              {
                                  "amount": "53.90",
                                  "code": "US"
                              },
                              {
                                  "amount": "4.50",
                                  "code": "XF"
                              }
                          ],
                          "refundableTaxes": "5.60"
                      },
                      "fareDetailsBySegment": [
                          {
                              "segmentId": "1",
                              "cabin": "BUSINESS",
                              "fareBasis": "VH7OAVFN",
                              "brandedFare": "FR",
                              "class": "D",
                              "includedCheckedBags": {
                                  "quantity": 2
                              }
                          }
                      ]
                  }
              ]
          }
      }
      if(values ){
          values[ "rentcar"] =   values[ "rentcar"] ? "Y":'N'
          values[ "bookTaxi"] =   values[ "bookTaxi"] ? "Y":'N'
          values[ "needFlight"] =   values[ "needFlight"] ? "Y":'N'
          values[ "privateparking"] =   values[ "privateparking"] ? "Y":'N'
          values[ "otherDetails"] =   values[ "otherDetails"] ?  values[ "otherDetails"]:"UI HardCoded SVMed facility"
      }
      let comCardAndTraveller = {
        offer:null,
        product:null,
        card : values,
        traveller: null
      }  
      if(this.props.my_data_flyreview &&  this.props.my_data_flyreview.offer){
        comCardAndTraveller.offer = this.props.my_data_flyreview.offer
    }
      console.log('sv flysubmit oct3 1')
      console.log(this.props.my_data_flyreview)
      let airbooking_expected =  {
        "productCategoryCode": 5,
        "productName": "AlaskaVacationKate57",
        "productDetails": "AlaskaVacationKate57",
        "description": "Alaska Kate57",
        "producttype": "svr",

        "flight_space_id": 57,
        "flight_space_key": "57@1515@81@BLD",

        "sale_ind": "Y",
        "vernacularcode": "en",
        "sojourncode": "RM41",

        "startdate": "2024-11-24",
        "enddate": "2026-11-24",

        "commoditytype": "RMc",
        "companycode": "SVR",
        "week": 11,
        "year": 24,
        "exchange_value": 12,
        "season": "RED",
       
        "bkgrnd_srch_sw": "Y",
        "pool": "NAMER",
        "maxoccupancy": "2",
        "flight_rack_rate": 23,
        "webStatusFlag": "Y",
        "srciata": "81",
        "dstiata": "BLD",
        "airlinesNameIata": "YR",
        "airlinesCodeIata": 1514,
        "flightAirlineNumStops": 1,
        "flightDepartureTimeTzest": "2024-08-18T05:08:08+0630",
        "flightArrivalTimeTzest": "2024-09-18T05:08:08+0630",
        "flightOperatedBy": "4009  Envoy Airlines",
        "flightOperatedOwned": "Y",
        "flightTimeHhmm": "6hr 29min",
        "svCleanupColPending": "Y",
        "flightid": 57,
        "languagecode": "en",
        
       
       
      
       
       
        "svrtypeid": "SVR"
        
       
        


       
    }
    /*
 we are getting 
  {
        "airport_id": 30009,
        "origin_airport_code": 1,
        "origincity": "HOMER",
        "origin_airport_city": "HOMER",
        "origin_airport_country": "USA",
        "origin_airport_timezone": "America/New_York",
        "port_code_iata": 30009,
        "airlines_db_id": 146,
        "origin_airport_iata": "09A",
        "dst_airport_code": "ADQ",
        "airlines_vessel": "CR9",
        "airlines_name_iata": "2O",
        "airlines_code_iata": 4,
        "flight_space_id": 13,
        "flight_departure": "10:30",
        "flight_departure_time": "10:30",
        "flight_arrival": "04:30",
        "flight_arrival_time": "04:30",
        "flight_airline_num_stops": 1,
        "flight_arrival_daytime": "PM",
        "flight_departure_daytime": "AM",
        "startdate": "2023-11-24",
        "enddate": "2026-12-01",
        "airlines_name": "Air Salone",
        "org_aiport_csc_addr": "HOMER,ALASKA,USA",
        "flight_time_hhmm": "6hr 29min",
        "flight_time": 209,
        "flight_operated_by": "4009 operated by Envoy Airlines",
        "flight_operator_owned": "Y",
        "origin_airport_state": "ALASKA",
        "flight_departure_time_tzest": "2025-10-25T10:30:00-0400",
        "flight_departure_date": "2025-10-25",
        "flight_arrival_date": "2025-10-26",
        "flight_arrival_time_tzest": "2025-10-26T16:30:00-0400",
        "flight_space_key": "1@4@1@ADQ"
    }
    */
    if(this.props.my_data_flyreview &&  this.props.my_data_flyreview.booking){
        let b = this.props.my_data_flyreview.booking
       
        airbooking_expected["startdate"] = b["startdate"]
        airbooking_expected["enddate"] = b["enddate"]
        airbooking_expected["srciata"] =  b["origin_airport_iata"] ?  b["origin_airport_iata"]:""
        airbooking_expected["dstiata"] =  b["dst_airport_code"] ?  b["dst_airport_code"]:""

        airbooking_expected["airlinesNameIata"] =  b["airlines_name_iata"] ?  b["airlines_name_iata"]:"YE"
        airbooking_expected["airlinesCodeIata"] =  b["airlines_code_iata"] ?  b["airlines_code_iata"]:1514

        airbooking_expected["flightAirlineNumStops"] =  b["flight_airline_num_stops"] ?  b["flight_airline_num_stops"]:1
        airbooking_expected["flightDepartureTimeTzest"] =  b["flight_departure_time_tzest"] ?  b["flight_departure_time_tzest"]:"2025-10-25T10:30:00-0400"
        airbooking_expected["flightArrivalTimeTzest"] =  b["flight_arrival_time_tzest"] ?  b["flight_arrival_time_tzest"]:"2025-10-25T10:30:00-0400"
        airbooking_expected["flightOperatedBy"] =  b["flight_operated_by"] ?  b["flight_operated_by"]:""
        airbooking_expected["flightOperatedOwned"] =  b["flight_operator_owned"] ?  b["flight_operator_owned"]:""
        airbooking_expected["flightTimeHhmm"] =  b["flight_time_hhmm"] ?  b["flight_time_hhmm"]:""
        airbooking_expected["flightid"] =  b["flight_id"] ?  b["flight_id"]:57
        airbooking_expected["languagecode"] =  b["languagecode"] ?  b["languagecode"]:"en"

        airbooking_expected["productCategoryCode"] =  b["productCategoryCode"] ?  b["productCategoryCode"]:5
        airbooking_expected["productName"] =  b["productName"] ?  b["productName"]:"AlaskaVacationKate57"
        airbooking_expected["productDetails"] =  b["productDetails"] ?  b["productDetails"]:"AlaskaVacationKate57"
        airbooking_expected["description"] =  b["description"] ?  b["description"]:"Alaska Kate57"
        airbooking_expected["producttype"] =  b["producttype"] ?  b["producttype"]:"svr"
       
        airbooking_expected["flight_space_id"] = b["flight_space_id"]
        airbooking_expected["flight_space_key"] = b["flight_space_key"]


        airbooking_expected["sale_ind"] =  b["sale_ind"] ?  b["sale_ind"]:"Y"
        airbooking_expected["vernacularcode"] =  b["vernacularcode"] ?  b["vernacularcode"]:"en"
        airbooking_expected["sojourncode"] =  b["sojourncode"] ?  b["sojourncode"]:"RMC"
        airbooking_expected["companycode"] =  b["companycode"] ?  b["companycode"]:"SVR"

        airbooking_expected["week"] =  b["week"] ?  b["week"]:11
        
        airbooking_expected["year"] =  b["year"] ?  b["year"]:24
        airbooking_expected["exchange_value"] =  b["exchange_value"] ?  b["exchange_value"]:12
        airbooking_expected["season"] =  b["season"] ?  b["season"]:"RED"
        airbooking_expected["bkgrnd_srch_sw"] =  b["bkgrnd_srch_sw"] ?  b["bkgrnd_srch_sw"]:"Y"
        airbooking_expected["pool"] =  b["pool"] ?  b["pool"]:"NAMER"

        airbooking_expected["maxoccupancy"] =  b["maxoccupancy"] ?  b["maxoccupancy"]:"2"
        airbooking_expected["flight_rack_rate"] =  b["flight_rack_rate"] ?  b["flight_rack_rate"]:23
        airbooking_expected["webStatusFlag"] =  b["webStatusFlag"] ?  b["webStatusFlag"]:"Y"
        


       
        

    }
      if(this.props.my_data_flyreview &&  this.props.my_data_flyreview.booking){

          comCardAndTraveller.reservationAirProduct = airbooking_expected

      }
      console.log('sv flysubmit oct3 2')
      console.log(this.props.my_data_flyreview)
      if(this.props.my_data_traveller){
          let tvalues = this.props.my_data_traveller

          tvalues[ "state"] =   tvalues[ "state"] ?  tvalues[ "state"]:"CA"
          if(tvalues[ "bookingAgentType"]){
            tvalues[ "bookingAgentType"] =  (tvalues[ "bookingAgentType"].toLocaleLowerCase() =="selftravel" ?  "S":"O") 
          }else{
            tvalues[ "bookingAgentType"] = "S"
          }
         
          if(tvalues[ "traveType"]){
            tvalues[ "traveType"] =  (tvalues[ "traveType"].toLocaleLowerCase() =="personal" ?  "P":"B") 
          }else{
            tvalues[ "traveType"] = "P"
          }
         

          

        comCardAndTraveller['traveller'] = tvalues
      }
      let documents = []
      let tocvalues = null
      let pvalues = null
      /*
      if(this.props.my_data_svdoc){
          pvalues = _.clone(this.props.my_data_svdoc)
           
          for(let i=0; i < pvalues.members.length; i++){
              if(pvalues.members[i].holder ==  'Y'){
                pvalues.members[i].holder = true
              }else{
                pvalues.members[i].holder = false

              }
              if(pvalues.members[i].documentNumber &&( pvalues.members[i].documentNumber.length > 0) ) {
                pvalues.members[i].number  = pvalues.members[i].documentNumber
              }

          }
          documents = pvalues.members
          comCardAndTraveller['documents'] = documents
          comCardAndTraveller['documents'] = documents
          comCardAndTraveller['my_data_svdoc'] = pvalues
      }
      */
      if(this.props.my_data_svtoc){
        //let one_pers = this.props.my_data_svtoc
        let one_pers = null
        let outer = this.props.my_data_svtoc
        console.log('***NOV8 tocvalues **8')
        console.log(outer)
        let ta  = []
        let p_ob = null
        if(_.isArray(outer)){
            console.log('SV****BIG ERORR OUTE NEEDS oto BE Wrapper of members shich are pers')
            one_pers  = outer[0].members
        }else{
            if(_.isArray(outer.members)){
                ta = outer.members
            }else{
                console.log('SV****BIG ERORR WE NEED MIN 1')
                ta = outer.members[0]
            
            }
            
        }
        /*
        if(_.isArray(one_pers)){
            ta  = one_pers.members
        }else{
            p_ob =one_pers
            ta.push(p_ob)
        }
        */
        for(let i=0; i < ta.length; i++){
            let tob = ta[i]
            if(!( tob && tob.members) ) {
                continue
            }
            console.log("nov 10 *  tob.members ")
            console.log(tob)
            let tmembers = tob.members
            
            console.log(tmembers)


         
            for(let i=0; i < tmembers.length; i++){
                if(tmembers[i].holder ==  'Y'){
                    tmembers[i].holder = true
                }else{
                    tmembers[i].holder = false

                }
                if(tmembers[i].documentNumber &&( tmembers[i].documentNumber.length > 0) ) {
                    tmembers[i].number  = tmembers[i].documentNumber
                }

            }

        }
        tocvalues = ta

        if(pvalues && pvalues.members){
            documents = pvalues.members
        }
        console.log('sv** NOV11 ******8ta  my_data_svtocfor m')
        console.log(ta)
        comCardAndTraveller['documents'] = documents ? documents : {}
        
        comCardAndTraveller['my_data_svtoc'] = ta 
    }

    if(pvalues && pvalues.members){
        comCardAndTraveller['my_data_svdoc'] = pvalues ? pvalues : {}
    }
       
    /*svdec27 start*/
    let airOrderItemPrice = {
        "orderId": -1,
        "productId": -1,
        "customerId": -1,
        "itemId": -1,
        "itemOrderQuantity": 1,
        "orderItemStatusCode": 1,
        "discountPrice": 0.0,
        "discountPercent": 0.0,
        "taxPercent": 6.0,
        "cityTaxPercent": 6.5,
        "deposit": 200.0,
        "depositPercent": 0.0,
        "basePrice": 800.0,
        "salePrice": 1000.0,
        "total": 0.0,
        "reservationConfirmCode": "GHLKX",
        "currency": "USD"
    }
    comCardAndTraveller["airOrderItemPrice"] = airOrderItemPrice

    if(comCardAndTraveller.offer && (comCardAndTraveller.offer != null)){
        let toffer = comCardAndTraveller.offer
       
        airOrderItemPrice.currency = toffer.price.currency ? toffer.price.currency : "USD"
        if(typeof(toffer.price.base) == "string"){
            airOrderItemPrice.basePrice  = parseInt(toffer.price.base )
        }else{
            airOrderItemPrice.basePrice = toffer.price.base
        }


  
        
        
        if(typeof(toffer.price.total) == "string"){
            airOrderItemPrice.total   = parseInt(toffer.price.total )
        }else{
            airOrderItemPrice.total   = toffer.price.total
        }

       
        if(typeof(toffer.price.grandTotal) == "string"){
            airOrderItemPrice.salePrice  = parseInt(toffer.price.grandTotal )
        }else{
            airOrderItemPrice.salePrice = toffer.price.grandTotal
        }


    }
    /*svdec27 end*/

        
        
      let meta = {
        "addressId": -1,
        "customerId": -1,
        "cardId": -1

      }
      console.log('sv flysubmit oct3 3')
      console.log(this.props.my_data_flyaddress)
      if(this.props.my_data_flyaddress &&  this.props.my_data_flyaddress.addressId &&  ( this.props.my_data_flyaddress.addressId >0)){
        meta.addressId = this.props.my_data_flyaddress.addressId
      }

      if(this.props.my_data_flyaddress &&  this.props.my_data_flyaddress.customerId &&  ( this.props.my_data_flyaddress.customerId >0)){
        meta.customerId = this.props.my_data_flyaddress.customerId
      }

      if(this.props.my_data_card &&  this.props.my_data_card.cardId &&  ( this.props.my_data_card.cardId >0)){
        meta.cardId = this.props.my_data_card.cardId
      }
      /*svj22 datecomponents are addint timevalues */
      comCardAndTraveller.TRAVELLER_DATE_HAS_TIME = "N"
       /*svj22 datecomponents are addint timevalues end */
      comCardAndTraveller.meta = meta
      console.log('** NOV5 *******ENDING TRAvelled from UI flysubmit Nov 5************************* ')
      console.log(comCardAndTraveller)

      const { cookies } = this.props;
      const svtv = cookies.get('svt')
      console.log('sv flysubmit oct3 5 calling flypriceAndTexNowSecure ')
      console.log(comCardAndTraveller)
      /* we donot have customerid */
     return this.props.flypriceAndTexNowSecure(comCardAndTraveller,svtv)
    
  
    }

    getSVDBTokenOffer(svtv){
        //loadAddressDet(id)
        let stoken = "mm"
        let rob = {
            "docId": [
                "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwYXltZW50TWV0aG9kQ29kZSI6ImNhcmQiLCJuYW1lIjoiam9uYiIsImZuYW1lIjoiam9uIiwibG5hbWUiOiJiZXRhIiwicGhvbmUiOiI1MTIxMjM0MzIyIiwiZW1haWwiOiJqb25AeWFob28uY29tIiwiYWRkcmVzcyI6IjEyIGxpbnZvYyIsImxvZ2luIjoiam9uQHlhaG9vLmNvbSIsInBhc3N3b3JkIjoiUGV0ZTEyMyIsInBhc3N3b3JkbWlycm9yIjoiUGV0ZTEyMyIsImVuY3Bhc3N3b3JkIjoiUGV0ZTEyMyIsIm90aGVyRGV0YWlscyI6Ik5lZWQgcGlja3VwIiwiaXNkY29kZSI6IjEiLCJjdXN0b21lcklkIjo3LCJjcmVhdGVkQnkiOiJBYm9kZVN5c3RlbUFkbWluIiwibW9kaWZpZWRCeSI6IkFib2RlU3lzdGVtQWRtaW4iLCJjcmVhdGVkRGF0ZSI6IjIwMjQtMDctMTNUMDE6NDk6MzQuMDAwKzAwMDAiLCJtb2RpZmllZERhdGUiOiIyMDI0LTA3LTEzVDAxOjQ5OjM0LjAwMCswMDAwIiwiaWF0IjoxNzMzMTgzODg0LCJleHAiOjE3MzMxODc0ODR9.Io5nwoDqc92G-vEMHnMWBeyJ-f_T1yByatrqfnd1_5Q"
            ],
            "hsetname": "HotelInvDB"
        }
        

        if(svtv ){
            stoken  = svtv
            let ar = []
            ar.push(svtv)
            rob[ "docId"] = ar
        }
        console.log('sv a888adreddcotainer getrs id')
        this.props.getUserOffer(rob)
        
        //this.props.sojDetailsAndImagesSV("mancreek") 
        /*this.props.getSojournDetails("mancreek") */
       
    }
    componentWillMount()	{
        console.log('sv--task=--- link sends us params')
        console.log(this.props.svparams)
        const { cookies } = this.props;
        let svoffer = cookies.get('svoffer')
        console.log('sv-OCT25**********-task=--- cookies sends us svoffer ')
        /*svnov13  start*/
        console.log('sv-Nov13**********-task=--- cookies  ')
        let svcookoffer_o =cookies.get('svcook')
        /*
        we call 1 method in action that is sequent  call getSVDBTokenOffer
        aabs then calls getAppDetailsMyReservation based on cstomerId
        
        if(SV_SOJ_LOCALSTORAGE_TYPE === 'SVDB'){
            let svt_str =cookies.get('svt')
            this.props.getSVDBTokenOffer(svt_str)
        }else{
            let svcookoffer_o =cookies.get('svcook')

        }
        */
        console.log(svcookoffer_o)
        console.log('sv-Nov13**********-task=--- end cookies  ')
        /*svnov13  end*/
         //console.log(this.props.svparams.id)
         const {dataProfile, svcustProfile, custProfile} = this.props
         console.log('sv--dara profie from HOC+')
        console.log(dataProfile)
        console.log('sv--dara svcustProfile from HOC+')
        console.log(svcustProfile)
        console.log('sv--dara svcustProfile from svreviewreducer+')
        console.log(custProfile)
       // let custProfile = svcustProfile
         console.log('sv--dara profie from HOC end')
         

         let id;
         if(this.props.svparams){
            id = this.props.svparams.id
         
         }else{
          console.log('not called by router')
          id = 1;
          if(dataProfile && dataProfile.spaceKey){
              id = dataProfile.spaceKey;
          }
         }
        
    console.log('sbv--sjourn id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:'+ id)
    
       if(svcustProfile && svcustProfile.customerId > 0){
        let flyob = {
            "svcookoffer_o": svcookoffer_o ? svcookoffer_o : null,
            "id":id
           }
        this.getAppDetailsMyReservation(flyob,svcustProfile )
           /*
           this.getAppDetailsMyReservation(id,svcustProfile )
        */
        
       }else{
           let flyob = {
            "svcookoffer_o": svcookoffer_o ? svcookoffer_o : null,
            "id":id
           }
       // this.getAppDetails(id)
       
       console.log('**********sbv--MARCH31SV lyob wih ofefer and  id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:')
       console.log(flyob)
       this.getAppDetails(flyob)
       }
       
       // this.props.priceAndTexNow(id);
   
			
			
	

	}

    getPricedetContainer(my_data_flyreview){
        let price = null
        if(my_data_flyreview && my_data_flyreview.price){
            price = my_data_flyreview.price
        }
        
       
        return (
            <div className="rev-row ">
                <div className="card card--raised with-shadow">
                <p className="sd-content"> <text> Yours Price Summary </text></p>
                <div className="box-outer">
                    <div className="box-left">
                        <text> Total </text>
                    </div>

                    <div className="box-right">

                        <p><text className="f19">{price.currency}{price.total?price.total :'923.46' }  </text></p>
                        <p><text className="f17sv">Include taxes and fees </text></p>


                    </div>

                </div>
                <p className="sd-content"> <text> $80 average per person </text></p>
                <p className="sd-content"> <text> Price Information </text></p>
                <p><span style={{fontSize: "16px"}} > <Icon  style={{ color: 'rgb(206, 209, 24)' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>IncludeSV {price.currency} {price.tax.taxTotal?price.tax.taxTotal:'$102.34' } in taxes and fess </text></span></p>
                {/* 
                <p> <text className="tax-bl-total"> Incude {price.tax.taxTotal?price.tax.taxTotal:'$102.34' } in taxes and fess </text></p>
                 */}
                <p>
                <dl>
                    <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> {price.tax.taxPercent?price.tax.taxPercent :'$6' } % MainTAX </text></span></dt>
                    <dd className="tax-ib-amt"><span className="n2">{price.currency}{price.tax.maintax?price.tax.maintax:'49.26' } </span> </dd>
                </dl>

                </p>
                <p>
                <dl>
                    <dt className="tax-ib-info"><span className="nh"><text className="tax-line">{price.tax.citytaxPercent?price.tax.citytaxPercent :'6.5' }  % City TAX </text></span>
                    </dt>
                    <dd className="tax-ib-amt"><span className="n2"> {price.currency}{price.tax.citytax?price.tax.citytax :'53.26' }  </span> </dd>
                </dl>
                </p>
               
                </div>  
            </div>
)
    }
    getEconomyCabinClassContainer_amb(my_data_flyreview, svoffer){
        let booking = null, svr_location, soj, rating_info, rating_text, rating_num
        let amenity_name = []
        const {travelerPricings} = svoffer
        

        if(my_data_flyreview && my_data_flyreview.booking){
           
        }
       
        return (
            <AmbTravellersDetailView travelerPricings={travelerPricings}></AmbTravellersDetailView>
 )

    }
    getPricedetContainer_amb(my_data_flyreview, svoffer){
        let price = null
        
        if(my_data_flyreview && my_data_flyreview.price){
            price = my_data_flyreview.price
        }
        
        let {offer} = my_data_flyreview
        if(!offer){
            offer = {
                "type": "flight-offer",
                "id": "1",
                "source": "GDS",
                "instantTicketingRequired": false,
                "nonHomogeneous": false,
                "paymentCardRequired": false,
                "lastTicketingDate": "2024-10-25",
                "itineraries": [
                    {
                        "segments": [
                            {
                                "departure": {
                                    "iataCode": "EWR",
                                    "terminal": "B",
                                    "at": "2024-11-01T19:29:00"
                                },
                                "arrival": {
                                    "iataCode": "SFO",
                                    "terminal": "1",
                                    "at": "2024-11-01T22:53:00"
                                },
                                "carrierCode": "AS",
                                "number": "295",
                                "aircraft": {
                                    "code": "73H"
                                },
                                "operating": {
                                    "carrierCode": "AS"
                                },
                                "duration": "PT6H24M",
                                "id": "1",
                                "numberOfStops": 0,
                                "co2Emissions": [
                                    {
                                        "weight": 612,
                                        "weightUnit": "KG",
                                        "cabin": "BUSINESS"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "price": {
                    "currency": "USD",
                    "total": "788.07",
                    "base": "719.07",
                    "fees": [
                        {
                            "amount": "0.00",
                            "type": "SUPPLIER"
                        },
                        {
                            "amount": "0.00",
                            "type": "TICKETING"
                        },
                        {
                            "amount": "0.00",
                            "type": "FORM_OF_PAYMENT"
                        }
                    ],
                    "grandTotal": "788.07",
                    "billingCurrency": "USD"
                },
                "pricingOptions": {
                    "fareType": [
                        "PUBLISHED"
                    ],
                    "includedCheckedBagsOnly": true
                },
                "validatingAirlineCodes": [
                    "AS"
                ],
                "travelerPricings": [
                    {
                        "travelerId": "1",
                        "fareOption": "STANDARD",
                        "travelerType": "ADULT",
                        "price": {
                            "currency": "USD",
                            "total": "788.07",
                            "base": "719.07",
                            "taxes": [
                                {
                                    "amount": "5.00",
                                    "code": "ZP"
                                },
                                {
                                    "amount": "5.60",
                                    "code": "AY"
                                },
                                {
                                    "amount": "53.90",
                                    "code": "US"
                                },
                                {
                                    "amount": "4.50",
                                    "code": "XF"
                                }
                            ],
                            "refundableTaxes": "5.60"
                        },
                        "fareDetailsBySegment": [
                            {
                                "segmentId": "1",
                                "cabin": "BUSINESS",
                                "fareBasis": "VH7OAVFN",
                                "brandedFare": "FR",
                                "class": "D",
                                "includedCheckedBags": {
                                    "quantity": 2
                                }
                            }
                        ]
                    }
                ]
            }
        }
        if(svoffer){
            offer = svoffer
        }
        if (offer.price){
            price = offer.price
        }
        return (
           <AmbPriceSummaryView price={price}></AmbPriceSummaryView>
)
    }
    getBookdetContainer(my_data_flyreview){
        
        let Request = null
        if(my_data_flyreview && my_data_flyreview.Request){
            Request = my_data_flyreview.Request
        }
        const stayWithUnits = (Request.stay? Request.stay: '6')  + ' ' + (Request.stayInit? Request.stayInit: 'nights') 
        return(
            <div className="rev-row">
             <div className="card card--raised with-shadow">
                <p className="sd-content"> <text> Yoursv Booking Details </text></p>
                <div className="box-outer">
                    <div className="rev-sd-left">
                        <p className="sd-check"><text>Check-in </text></p>
                        <p className="sd-content"><text>{Request.checkinTime?Request.checkinTime :'Tue, Dec 10, 2024 ' } </text></p>
                        <p className="sd-check"><text>{Request.checkinTimePrefix?Request.checkinTimePrefix :'From 3:00 PM' } </text></p>
                    </div>

                    <div className="rev-sd-right">

                        <p className="sd-check"><text>Check-out </text></p>
                        <p className="sd-content"><text>{Request.checkoutTime?Request.checkoutTime :'Fri, Dec 13, 2024' }  </text></p>
                        <p className="sd-check"><text>{Request.checkoutTimePrefix?Request.checkoutTimePrefix :'Until 11:00 AM' }  </text></p>

                    </div>

                </div>

                <p> <text> Total length of stay </text></p>
                <p> <text> {stayWithUnits? stayWithUnits:'6 nights' } </text></p>
            </div>
            </div>)
    }
    getEconomyCabinClassContainer(my_data_flyreview){
        let booking = null, svr_location, soj, rating_info, rating_text, rating_num
        let amenity_name = []

        if(my_data_flyreview && my_data_flyreview.booking){
           
        }
       

        return(  <div className="rev-row ">
            
            <div className="card card--raised with-shadow">
            
                
           
        <p className="sd-check"><text>Round Trip </text></p>
        <p className="sd-content"> <text>Main Class</text></p>
        <p className="sd-check"> <text> 13 Color Apt, Reed Av, San Jose
                       </text>
        </p>
        <p className="sd-rating"> <text style={{fontSize:'12px', fontWeight:'300'}}>{rating_info? rating_info:'Excellent, 9.1' }   </text></p>
        
        <p className="sd-numreview">  <span style={{fontSize: "14px"}} ><Tag color="magenta">5.0</Tag> <text ><span style={{paddingLeft: "10px"}}>Good,</span> <span> 13 Reviews </span></text></span></p>
        
        
         
        <div className="box-left-listhotels">
                                           
                                            <p className="m-para-text">
                                           
                                                <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#122f96' }} type="audio" theme="filled" /><text style={{paddingLeft: "10px"}}>Board In Group 6</text></span>
                                               
                                                
                                            </p>
                                            <p className="m-para-text">
                                           
                                                  <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#ebff96' }} type="bank" theme="filled" /><text style={{paddingLeft: "10px"}}>Changes Allowed</text></span>
                                                
                                                
                                            </p>
                                            <p className="m-para-text">
                                           
                                            <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#ebff96' }} type="bank" theme="filled" /><text style={{paddingLeft: "10px"}}>Extra Leg Space</text></span>
                                           
                                           
                                       </p>
        </div>
        <div className="box-left-listhotels">
                                           
                                            <p className="m-para-text">
                                           
                                                <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#122f96' }} type="audio" theme="filled" /><text style={{paddingLeft: "10px"}}>Pay To Check Bags</text></span>
                                               
                                                
                                            </p>
                                            <p className="m-para-text">
                                           
                                                  <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#ebff96' }} type="bank" theme="filled" /><text style={{paddingLeft: "10px"}}>Pay To  Main Cabin Seat</text></span>
                                                
                                                
                                            </p>
                                            <p className="m-para-text">
                                           
                                            <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#ebff96' }} type="bank" theme="filled" /><text style={{paddingLeft: "10px"}}>Pay To  Choose Another Same Day Flight</text></span>
                                           
                                           
                                       </p>
        </div>
       

        </div>
        
    </div>
)
    }
    getAllLegsRightContainer(my_data_flyreview){
       // const {spaceDet} = my_data_flyreview
       let spaceDet = {
        
        "space_details": "Queen Room with Two Queen Beds",
        "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
        "cancellation": "Free cancellation before December 9, 2024 ",
        "guests": "2 adults ",
        "cleaniness_score" : "7.7",
        "non_smoking":true,

        "space_amenity_name": [
            "300 feet elevator",
            "air conditioning",
            "private bathroom"
        ]
       
       
    }
        let booking = null
        let soj = spaceDet 
        let amenities =[
            "Wi-Fi",
            "AC Power",
            "USB Power",
            "Personal Device Streaming"
        ]
        
        if(my_data_flyreview && my_data_flyreview.spaceDet){
            spaceDet = my_data_flyreview.spaceDet
        }
        if(my_data_flyreview && my_data_flyreview.booking){
            booking = my_data_flyreview.booking
        }
        if(booking && booking.en_activity_name_lvl && booking.en_activity_name_lvl.length > 0){

            amenities = booking.en_activity_name_lvl
        }else if(my_data_flyreview && my_data_flyreview.amenity_name && my_data_flyreview.amenity_name.length > 0){
            amenities = my_data_flyreview.amenity_name
        }

        //let amenities =  soj['amenity_name']?  soj['amenity_name'] : []
        return(
            <div className="rev-row">
            <div className="card card--raised with-shadow">

                <p className="right-sd-content"> 
                    <text>Austin, TX tov Phoenix, AZ </text>
                </p>
                <div className="sd-check"> 
                    <div><text style={{fontSize:"14px"}}> Flight 1 Of 2 </text> </div>
                    <div><text  style={{fontSize:"14px"}}> Friday, Jxanuary 16, 2025 </text></div>
                </div>

<div className="svr-itnlist-box-row1">
    <div className="o-container-itnrev">
        <div className="o-box-itnrev-b1">
                <span className="o-span">
           
                
                       
                    
                    <span>
                    <p className="m-para-text">
                    <span style={{fontSize: "14px"}} > <Icon  style={{ fontSize:'18px', color: 'rgb(55, 173, 219)' }} type="dashboard" theme="filled" /><text style={{color:'#cc8e3b', fontSze:'16px',  paddingLeft: "10px", paddingRight:'20px'}}>8:30 am</text><Icon type="line" /><text style={{ color: '#122196' }} style={{color:'#cc8e3b', fontSze:'16px', paddingLeft: "20px"}}>4:58 pm</text></span>
                        
                        <text style={{fontSize:'14px'}} className="svr-hotel-room d-block" >  San Jose (SJC) - Austin,TX (AUS) </text>
                       
                        <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#ca61a1', opacity:'0.9', fontSize:'16px' }} type="account-book" theme="filled" /><text style={{paddingLeft: "10px", color:'#898995'}}>Operated by SkyWest as American Eagles </text></span>

                       </p>
                    </span>
                
            

           
                </span>
        </div>
        <div className="o-box-itnrev">
            <span className="o-span">
                
                        <p className="m-para-text">
                        <span style={{fontSize: "14px"}} > <text style={{fontSize:'14px',color:'#768999'}} >6h 28m </text><Icon style={{paddingLeft: "10px", color: 'rgb(126, 181, 230)' , fontSize:'14px'}} type="cloud-upload"   /><text style={{fontSize:'14px',color:'#768999',paddingLeft: "10px"}} >2 Stop</text></span>
                            <text style={{fontSize:'14px'}} className="svr-hotel-room d-block"> 1h 42 m in DEN </text>
                            <text style={{fontSize:'12px',color:'#898995'}} className="f12  d-block"> United </text>
                            <text style={{fontSize:'12px',color:'#898995'}} className="f12  d-block">  CR7 CanadaAir RJ 700 </text>
                        </p>
                    
            </span>
        </div>
   </div>
</div>


<p className="right-sd-content"> <text>Phoenix, AZ to San Jose, CA </text></p>
<div className="sd-check"> 
                    <div><text style={{fontSize:"14px"}}> Flight 2 Of 2 </text> </div>
                    <div><text  style={{fontSize:"14px"}}> Friday, January 17, 2025 </text></div>
</div>

<div className="svr-itnlist-box-row1">
    <div className="o-container-itnrev">
        <div className="o-box-itnrev-b1">
                <span className="o-span">
           
                
                       
                    
                    <span>
                    <p className="m-para-text">
                    <span style={{fontSize: "14px"}} > <Icon  style={{ fontSize:'18px', color: 'rgb(55, 173, 219)' }} type="dashboard" theme="filled" /><text style={{color:'#cc8e3b', fontSze:'16px',  paddingLeft: "10px", paddingRight:'20px'}}>8:30 am</text><Icon type="line" /><text style={{ color: '#122196' }} style={{color:'#cc8e3b', fontSze:'16px', paddingLeft: "20px"}}>4:58 pm</text></span>
                        
                        <text style={{fontSize:'14px'}} className="svr-hotel-room d-block" >  San Jose (SJC) - Austin,TX (AUS) </text>
                        <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#ca61a1', opacity:'0.9', fontSize:'16px' }} type="account-book" theme="filled" /><text style={{paddingLeft: "10px", color:'#898995'}}>Delta operated by SV DBA Deltaz Connection</text></span>

                       </p>
                    </span>
                
            

           
                </span>
        </div>
        <div className="o-box-itnrev">
            <span className="o-span">
                
                        <p className="m-para-text">
                        <span style={{fontSize: "14px"}} > <text style={{fontSize:'14px',color:'#768999'}} >6h 28m </text><Icon style={{paddingLeft: "10px", color: 'rgb(126, 181, 230)' , fontSize:'14px'}} type="cloud-upload"   /><text style={{fontSize:'14px',color:'#768999',paddingLeft: "10px"}} >2 Stop</text></span>
                            <text style={{fontSize:'14px'}} className="svr-hotel-room d-block"> 1h 42 m in DEN </text>
                            <text style={{fontSize:'12px',color:'#898995'}} className="f12  d-block"> United </text>
                        </p>
                    
            </span>
        </div>
   </div>
</div>

<p className="sd-numreview"> <text> <span> Guests: </span> <span>  {spaceDet.guests? spaceDet.guests:'2 adults ,'}</span> </text></p>

<p className="sd-check"> <text> Cleanliness score – 2.0   </text></p>
<p className="sd-check"> <text> Non Smoking  </text></p>
<TerrainAmenitiesTabletReview  amenities={amenities}></TerrainAmenitiesTabletReview>



</div>
</div>

        )

    }
    getAddonRightContainer(){
         const {handleSubmit,svsubmitparent, pristine,  submitting }  = this
        return ( <div className="rev-row">
             <div className="card card--raised with-shadow">
        <p className="right-sd-content"> <text> Add to your stay </text></p>


        <div className="box-outer">
           {/* 
        <AddOnFormBusCom onSubmit={svsubmitparent}></AddOnFormBusCom>
             */}       
            <div className="add-ib-ck">
                <p className="sd-check"><text>ck </text></p>
            </div>

            <div className="add-ib-content">


                <p className="sd-check"><text>I will need a flight for my trip </text></p>
                <p className="sd-desc"><text>Flexible flight options from San Francisco to Orlando starting at
                        ‎$473‏ round-trip. Finish booking this stay to get flight recommendations that match
                        your selected dates. </text></p>


            </div>
            <div className="add-ib-icon">

                <p className="sd-check"><text>car </text></p>


            </div>

        </div>

        <div className="box-outer">
            <div className="add-ib-ck">
                <p className="sd-check"><text>
                    ck
                     </text></p>
            </div>

            <div className="add-ib-content">
                <p className="sd-check"><text>I m interested in renting a car </text></p>
                <p className="sd-desc"><text>Make the most of your trip – check out car rental options in your
                        booking confirmation.</text></p>
            </div>
            <div className="add-ib-icon">
                <p className="sd-check"><text>car </text></p>
            </div>

        </div>

        <div className="box-outer">
            <div className="add-ib-ck">
                <p className="sd-check"><text>ck </text></p>
            </div>

            <div className="add-ib-content">


                <p className="sd-check"><text>Want to book a taxi or shuttle ride in advance? </text></p>
                <p className="sd-desc"><text>Avoid surprises – get from the airport to your accommodations without
                        any hassle. We'll add taxi options to your booking confirmation.</text></p>


            </div>
            <div className="add-ib-icon">

                <p className="sd-check"><text>car </text></p>


            </div>

        </div>


        </div>

    </div>)
        
    }
    getSpecailRightContainer(){
        return ( <div className="rev-row">
             <div className="card card--raised with-shadow">
        <p className="right-sd-content"> <text> Special requests </text></p>
        <p className="sd-check"> <text>Special requests can't be guaranteed, but the property will do its best to
                meet your needs. You can always make a special request after your booking is complete.</text>
        </p>


        <div className="box-outer">
            <div className="add-ib-ck">
                <p className="sd-check"><text>ck </text></p>
            </div>

            <div className="add-ib-content">


                <p className="sd-check"><text>I would d like free private parking on site </text></p>


            </div>


        </div>



        </div>

    </div>
)
        
    }
    getArrivalRightContainer(){
        return (<div className="rev-row">
             <div className="card card--raised with-shadow">

        <p className="right-sd-content"> <text> Your arrival time </text></p>

        <p className="sd-check"> <text> our room will be ready for check-in at 3:00 PM </text></p>
        <p className="sd-check"> <text> 24-hour front desk – help whenever you need it! </text></p>

        <p className="sd-check"> <text style={{fontWeight:'300', color:'green', fontSize:'12px'}} > Time is for Orlando time zone </text></p>

</div>

    </div>
)
        
    }

    getCardRightContainers() {
        const legend = [{
            "sojourncode": "100",
            "vernacularcode": "EN",
            "sojourn_name": "253 Mancreek Resort"
        },
        {
            "sojourncode": "101",
            "vernacularcode": "EN",
            "sojourn_name": "253 John Resort"
        }]

       const {handleSubmit,svsubmitparent,svguestsaveparent,svguestsavesvtocparent,svguestsavesvdocparent, svrcsubmitparent,pristine,  submitting }  = this
        let data = [], hosts = [], dbs = [], sojourns = [], my_data = []
        if (this.props.data && (this.props.data.length > 0)) {
            data = this.props.data
        }
        //svf5 start
        const {my_data_dtoken,my_data_fly_price_confirmation, custProfile, my_data_flyaddress, my_data_card, my_data_geo,my_data_svtoc,my_data_svdoc,errob, crudsuccessob, errorRESERVATION } = this.props
        //svf5 end
        console.log('j10 DVFLywizard props track  my_data_geo IMP***')
        console.log(this.props)
        //my_data_svtoc_svcopy
        let my_data_svtoc_svcopy = {
            "id": "addLeft_step",
            "testlastName": "svlondon",
            "dateOfBirth": "1982-01-15",
            "members": [
                {
                    "tid": 1,
                    "dateOfBirth": "1982-01-15",
                    "gender": "MALE",
                    "firstName": "Svbsv",
                    "lastName": "Infinity",
                    "emailAddress": "svr@yahoo.com",
                    "memphones": [
                        {
                            "deviceType": "MOBILE",
                            "countryCallingCode": "34",
                            "number": "480080085"
                        }
                    ],
                    "members": [
                        {
                            "documentType": "IDENTITY_CARD",
                            "birthPlace": "Sanfrancisco",
                            "issuanceLocation": "Sanfrancisco",
                            "issuanceDate": "2015-04-13",
                            "documentNumber": "00000069",
                            "expiryDate": "2025-04-13",
                            "issuanceCountry": "US",
                            "validityCountry": "US",
                            "nationality": "US",
                            "holder": "Y"
                        }
                    ],
                    "id": "addLeft_STEP",
                    "gene": "addLeft_STEP",
                    "clubName": "SVBASEVALL"
                },
                {
                    "tid": 2,
                    "dateOfBirth": "1982-01-15",
                    "gender": "MALE",
                    "firstName": "Seteve",
                    "lastName": "Borrow",
                    "emailAddress": "steve@yahoo.com",
                    "memphones": [
                        {
                            "deviceType": "MOBILE",
                            "countryCallingCode": "1",
                            "number": "480080081"
                        }
                    ],
                    "members": [
                        {
                            "documentType": "IDENTITY_CARD",
                            "birthPlace": "Sanfrancisco",
                            "issuanceLocation": "Sanfrancisco",
                            "issuanceDate": "2015-04-13",
                            "documentNumber": "00000069",
                            "expiryDate": "2025-04-13",
                            "issuanceCountry": "US",
                            "validityCountry": "US",
                            "nationality": "US",
                            "holder": "Y"
                        }
                    ],
                    "id": "addLeft_STEP1",
                    "gene": "addLeft_STEP1",
                    "clubName": "Soccer"
                }
            ],
               "gender": "MALE"
        }
    
        if(!my_data_svtoc){
            console.log('SV NOV8# ****** my_data_svtoc NULL ISSSUE')
         }else{
            my_data_svtoc_svcopy = _.clone(my_data_svtoc)
         }

        let my_data_svdoc_svcopy = {
    
            "members": [
              {
                "documentType": "IDENTITY_CARD",
                "birthPlace": "San Jose",
                "issuanceLocation": "San Jose",
                "issuanceDate": "2015-04-13",
                "documentNumber": "00000069",
                "expiryDate": "2025-04-13",
                "issuanceCountry": "US",
                "validityCountry": "US",
                "nationality": "US",
                "holder": "Y"
              }
            ],
            id:'addLeft_STEP',
            gene:'addLeft_STEP',
            "clubName": "Soccer"
          
          
          }
        if(!my_data_svdoc){
           console.log('SV NOV# ****** my_data_svdoc NULL ISSSUE')
        }else{
            my_data_svdoc_svcopy = _.clone(my_data_svdoc)
        }
        console.log('SV CHECK# ******NOV3 my_data_svdoc SHOULD NIT BE NULL ISSSUE')
        console.log(my_data_svdoc_svcopy)

        
        console.log(crudsuccessob)
        console.log(errorRESERVATION)
        console.log('a29e***')
        
        return (
            <div>
                <SVFlyWizard errorRESERVATION={errorRESERVATION} errob={errob} crudsuccessob={crudsuccessob} my_data_dtoken={my_data_dtoken} my_data_card={my_data_card}  my_data_geo={my_data_geo} my_data_flyaddress={my_data_flyaddress} custProfile={custProfile} sv_price_confirmation={my_data_fly_price_confirmation} my_data_svtoc={my_data_svtoc_svcopy} my_data_svdoc={my_data_svdoc_svcopy}  svrcsubmitparent={svrcsubmitparent}   svguestsaveparent={svguestsaveparent} svguestsavesvtocparent={svguestsavesvtocparent} svguestsavesvdocparent={svguestsavesvdocparent} svsubmitparent={svsubmitparent} onSubmit={svsubmitparent} ></SVFlyWizard>
                {/* 
                
                <PaymentCardFormBusCom  onSubmit={svsubmitparent}   ></PaymentCardFormBusCom>
                     */}
                </div>   
                )
    }

    getHotelAmenityList(ar){
        
        
        ar = ar || []
       return ar.map( (v, idx)=>{
           if(v.toLocaleLowerCase() == "swimming beach"){
            return (<span style={{fontSize: "14px"}} > <HeartIcon style={{ color: 'hotpink' }} /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
        
           }else if(v.toLocaleLowerCase() == "tennis"){  
            return (<span style={{fontSize: "14px"}} > <Icon  style={{ color: '#122196' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
        

           }else if(v.toLocaleLowerCase() == "water"){  
            return (<span style={{fontSize: "14px"}} > <Icon  style={{ color: '#522f96' }} type="video-camera" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
        

           }else{

            return (<span style={{fontSize: "14px"}} > <Icon  style={{ color: '#122f96' }} type="audio" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
        
           }
          })
       


    }
    getChildContainers(svcookoffer_o){
        console.log('sv OCT28 *****SVFlyrevieew offer****',svcookoffer_o)
        
        /*   <FlyTerrainLocation  svrlocation={svr_location}></FlyTerrainLocation> */
        const lastestUpdateDate = 'Data Refresh Daily'
        let custProfile = null
        let soj = null, data = [], hosts = [], dbs = [], sojourns = [],my_data_flyreview = {} ,my_data = []
        let svrreview = {
           
            "num_reviews": 12364,
            "num_reviews_text": "reviews",
            "sv_rating": "Excellent",
            "sv_rating_no": 5
        }
        let svrstars = {
            "sv_rating_no": 5,
            "color": "#e8a01899"
        }
        let svr_tablets = []
        //let svr_tablets = ["http://localhost:8080/images/soj2.jpg", "http://localhost:8080/images/soj3.jpg", "http://localhost:8080/images/soj4.jpg", "http://localhost:8080/images/soj5.jpg", "http://localhost:8080/images/soj6.jpg" ]
        if (this.props.my_data && (this.props.my_data.length > 0)) {
            my_data = this.props.my_data
           // soj = my_data[0]
        }
        if (this.props.my_data_flyreview ) {
            my_data_flyreview = this.props.my_data_flyreview
            soj = my_data_flyreview.booking
          
        }
        if (this.props.custProfile ) {
            custProfile = this.props.custProfile
           
          
        }
        if (this.props.svr_soj_detail_images_ob && (this.props.svr_soj_detail_images_ob.gallery.length > 0)) {
            svr_tablets = this.props.svr_soj_detail_images_ob.gallery
           
        }
        soj = soj ? soj : {}
       
        let amenities =  soj['en_activity_name_lvl']?  soj['en_activity_name_lvl'] : []
        let highlights =  soj['highlights']?  soj['highlights'] : 'ante, venenatis non adipiscing vitae'
        let svr_location = {
            "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
            "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
            "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
            "county": soj['county'] ? soj['county'] : "albanyt",
            "postalcode":soj['postal_code'] ? soj['postal_code'] : 12193,
            "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
            "country": soj['country_name'] ? soj['country_name'] : "usa",
           "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
           "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
            
           "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
           "state":soj['state'] ? soj['state'] : "NY"

        }
        let svr_location_old = {
            "resort_name": soj['resort_name'] ? soj['resort_name'] : "253 Mancreek Resort" ,
            "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
            "county": soj['county'] ? soj['county'] : "albanyt",
            "postalcode":soj['postalcode'] ? soj['postalcode'] : 12193,
            "market_code":soj['market_code'] ? soj['market_code'] :  "NAMER",
            "country": soj['country'] ? soj['country'] : "usa",
           
            "state":soj['state'] ? soj['state'] : "NY",
        }
        let reservekey = 'insvreview'
        return (
            <div className="svr-det-pageWrapper">
    <header className="svr-header1">
        <h1> Flight View Detail</h1>
    </header>
    
    <FlyTerrainLocation my_data_flyreview={my_data_flyreview} reservekey={reservekey}   svrlocation={svr_location}></FlyTerrainLocation>
       
    <div className="svr-gal-contentWrapper">
        <aside className="siberbar-left" >
            <text style={{color:'#fff'}}>LEFT</text>
            {/*  
            <CardTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getEconomyCabinClassContainer(my_data_flyreview)}></CardTerrain>
            <CardTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getPricedetContainer(my_data_flyreview)}></CardTerrain>
           
            */}
            <CardTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getEconomyCabinClassContainer_amb(my_data_flyreview,svcookoffer_o)}></CardTerrain>
          
            <CardTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getPricedetContainer_amb(my_data_flyreview,svcookoffer_o)}></CardTerrain>
           
            {/* s1 hotel 
              
            <CardTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getBookdetContainer(my_data_flyreview)}></CardTerrain>
            
            */}
        </aside>
        <article className="main-right">
        <text style={{color:'#fff'}}>Main</text>
            {/*  
             <CardTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getAllLegsRightContainer(my_data_flyreview)}></CardTerrain>
           
            */}
             <CardTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getAllLegsRightContainer_amb(my_data_flyreview, svcookoffer_o)}></CardTerrain>
           
           
            <CardTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getCardRightContainers()}></CardTerrain>
            {/* m1 hotel 
           
           
           
            */}
            
            

        </article>
    </div>




    <br />


            {/*  

    <footer>
        <p>Copyright 2013, SV Greek Text Generator, Inc.</p>
        <p>Contact <a href="mailto:nobody@nowhere.com"> w-mail@xx.com</a> </p>
    </footer>
 */}

</div>
        
        )

    }

    render() {
        /*
        const location = useLocation()
        const { svoffer } = location.state
        console.log('svOfeer OCT25***************************', svoffer)
        */
        const lastestUpdateDate = 'Data Refresh Daily'
        const { title} = this
        const {dataProfile, custProfile} = this.props

       /*to do we donot neeed care - terrain is card . just planin textstyel images page to hsow terrrain  */
    
       const { cookies } = this.props;
       
       //let svcookoffer_o =cookies.get('svcook')
       /*svdec3 start*/
       let svcookoffer_o  = null

       if(SV_SOJ_LOCALSTORAGE_TYPE ==  "SVDB" ){
        console.log('********DEC3 **************** RENDER SVDB TO GET svcookoffer 1 ')
       
            const {my_data_flyreview, errorFLYRESERVATION,errob} = this.props
            let time = ((errob && errob.timestamp) ? errob.timestamp : "2026-08-23T02:27:18.038+0000"   )
            let timemsg = `Time number: ${time} COSMOS flight not available`
            if(errorFLYRESERVATION === true){

                return (
                    <div className="col-md-12">
                
             


                        <Result
                            status="error"
                            title="Flight Reservation is not available. SVAMCOS!"
                            subTitle={timemsg}
                            extra={[
                                <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/inetcosmos/svflysearch`}> Search Again   </Link></SVAButton>
                            
                            ]}
                        />
                 
                       
                    </div>
                )
            }
            if(my_data_flyreview && my_data_flyreview.offer){
                console.log('********DEC3 **************** RENDER SVDB TO GET svcookoffer 2 ')
     
            const {offer} = my_data_flyreview
            svcookoffer_o = offer
            console.log(svcookoffer_o)
            console.log('********DEC3 **************** RENDER SVDB TO GET svcookoffer 3 ')
     
    
            }

       }else{
        console.log('********DEC3 **************** RENDER SVCOOKIE TO GET svcookoffer 1 ')
         svcookoffer_o =cookies.get('svcook')
       }
      console.log(svcookoffer_o)
       console.log('svj10***********SVFlyReview render')
       console.log(this.props)
       
       /*svdec3 end*/
        

       console.log('********OCT25**************** COOKIES svcookoffer we might be creat START', svcookoffer_o)
       
       
       //let svcookoffer_o = JSON.parse(svcookoffer_s)

       
      
       console.log('********OCT25**************** COOKIES svcookoffer we might be creat END', svcookoffer_o)
       
       if(svcookoffer_o.itineraries.length  < 1){
        return (

            
            <div className="col-md-12">
                
                 
                <h3>HELLO NO OFEET -PLAEASE WAIT LOADING SERVER DATA</h3>
                
            </div>
        )

       }
          return (

            
            <div className="col-md-12">
                
                 
                <GlassTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getChildContainers(svcookoffer_o)}></GlassTerrain>
                
            </div>
        )
        
    }

    getAllLegsRightContainer_amb(my_data_flyreview, svoffer){
        // const {spaceDet} = my_data_flyreview
        let svcustProfile = {
            "customerId": -6,
            "addressId":-1
        }
        let amenities = [
            {
                "description": "STANDARD PIECE MAX 50LB 62LI",
                "isChargeable": true,
                "amenityType": "BAGGAGE",
                "amenityProvider": {
                    "name": "BrandedFare"
                }
            },
            {
                "description": "110V AC POWER",
                "isChargeable": false,
                "amenityType": "ENTERTAINMENT",
                "amenityProvider": {
                    "name": "BrandedFare"
                }
            }
        ]
        let amenities_old =[
            "Wi-Fi",
            "AC Power",
            "USB Power",
            "Personal Device Streaming"
        ]
        
        
        let {offer} = my_data_flyreview
        if(!offer){
            offer = {
                "type": "flight-offer",
                "id": "1",
                "source": "GDS",
                "instantTicketingRequired": false,
                "nonHomogeneous": false,
                "paymentCardRequired": false,
                "lastTicketingDate": "2024-10-25",
                "itineraries": [
                    {
                        "segments": [
                            {
                                "departure": {
                                    "iataCode": "EWR",
                                    "terminal": "B",
                                    "at": "2024-11-01T19:29:00"
                                },
                                "arrival": {
                                    "iataCode": "SFO",
                                    "terminal": "1",
                                    "at": "2024-11-01T22:53:00"
                                },
                                "carrierCode": "AS",
                                "number": "295",
                                "aircraft": {
                                    "code": "73H"
                                },
                                "operating": {
                                    "carrierCode": "AS"
                                },
                                "duration": "PT6H24M",
                                "id": "1",
                                "numberOfStops": 0,
                                "co2Emissions": [
                                    {
                                        "weight": 612,
                                        "weightUnit": "KG",
                                        "cabin": "BUSINESS"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "price": {
                    "currency": "USD",
                    "total": "788.07",
                    "base": "719.07",
                    "fees": [
                        {
                            "amount": "0.00",
                            "type": "SUPPLIER"
                        },
                        {
                            "amount": "0.00",
                            "type": "TICKETING"
                        },
                        {
                            "amount": "0.00",
                            "type": "FORM_OF_PAYMENT"
                        }
                    ],
                    "grandTotal": "788.07",
                    "billingCurrency": "USD"
                },
                "pricingOptions": {
                    "fareType": [
                        "PUBLISHED"
                    ],
                    "includedCheckedBagsOnly": true
                },
                "validatingAirlineCodes": [
                    "AS"
                ],
                "travelerPricings": [
                    {
                        "travelerId": "1",
                        "fareOption": "STANDARD",
                        "travelerType": "ADULT",
                        "price": {
                            "currency": "USD",
                            "total": "788.07",
                            "base": "719.07",
                            "taxes": [
                                {
                                    "amount": "5.00",
                                    "code": "ZP"
                                },
                                {
                                    "amount": "5.60",
                                    "code": "AY"
                                },
                                {
                                    "amount": "53.90",
                                    "code": "US"
                                },
                                {
                                    "amount": "4.50",
                                    "code": "XF"
                                }
                            ],
                            "refundableTaxes": "5.60"
                        },
                        "fareDetailsBySegment": [
                            {
                                "segmentId": "1",
                                "cabin": "BUSINESS",
                                "fareBasis": "VH7OAVFN",
                                "brandedFare": "FR",
                                "class": "D",
                                "includedCheckedBags": {
                                    "quantity": 2
                                }
                            }
                        ]
                    }
                ]
            }
        }
        if(svoffer){
            offer = svoffer
        }
       
        let priceInfo = {
            o:offer,
            customerId:-1
        }
        let reservekey = 'insvreview'

        if( offer && offer.travelerPricings && (offer.travelerPricings.length >0) && (offer.travelerPricings[0].fareDetailsBySegment) &&  offer.travelerPricings[0].fareDetailsBySegment[0].amenities){
            amenities = offer.travelerPricings[0].fareDetailsBySegment[0].amenities
        }else{
            amenities = [
                {
                    "description": "STANDARD PIECE MAX 50LB 62LI",
                    "isChargeable": true,
                    "amenityType": "BAGGAGE",
                    "amenityProvider": {
                        "name": "BrandedFare"
                    }
                },
                {
                    "description": "110V AC POWER",
                    "isChargeable": false,
                    "amenityType": "ENTERTAINMENT",
                    "amenityProvider": {
                        "name": "BrandedFare"
                    }
                }
            ]
        }
        let spaceDet = {
         
         "space_details": "Queen Room with Two Queen Beds",
         "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
         "cancellation": "Free cancellation before December 9, 2024 ",
         "guests": "2 adults ",
         "cleaniness_score" : "7.7",
         "non_smoking":true,
 
         "space_amenity_name": [
             "300 feet elevator",
             "air conditioning",
             "private bathroom"
         ]
        
        
     }
         let booking = null
         let soj = spaceDet 
         /*
         let amenities =[
             "Wi-Fi",
             "AC Power",
             "USB Power",
             "Personal Device Streaming"
         ]
         */
         if(my_data_flyreview && my_data_flyreview.spaceDet){
             spaceDet = my_data_flyreview.spaceDet
         }
         if(my_data_flyreview && my_data_flyreview.booking){
             booking = my_data_flyreview.booking
         }

         
         let itn = offer.itineraries[0]
         let segStart = itn.segments[0] 
         let sum_org = segStart.departure.iataCode
         let n = itn.segments.length
         let segEnd = itn.segments[n-1]
         let sum_departure = segStart.departure.at
 
         let sum_arrival = segEnd.arrival.at
     let sum_dst = segEnd.arrival.iataCode
     let sum_stops = n -1
    
     //let sum_duration_dis = this.fltTime(sum_duration)
     //let sum_airlines = 'ZZ'
      let sum_airlines = segStart.carrierCode

         /*
         if(booking && booking.en_activity_name_lvl && booking.en_activity_name_lvl.length > 0){
 
             amenities = booking.en_activity_name_lvl
         }else if(my_data_flyreview && my_data_flyreview.amenity_name && amenity_name.length > 0){
             amenities = my_data_flyreview.amenity_name
         }
         */
         //let amenities =  soj['amenity_name']?  soj['amenity_name'] : []
         return(
             <div className="rev-row">
                <div className="card card--raised with-shadow">
 
                        <p className="right-sd-content"> 
                            <text>{sum_org} to {sum_dst} </text>
                        </p>
                        <div className="svr-spacelist-box-row1">
                            {/*  
                            <AmbOfferReview priceInfo={priceInfo} svcustProfile={svcustProfile} reservekey={reservekey} ></AmbOfferReview>
                            
                            */}
                            <AmbOfferItnReview priceInfo={priceInfo} svcustProfile={svcustProfile} reservekey={reservekey} ></AmbOfferItnReview>
                                            

                        </div>
                        
                        
        
                        <p className="sd-numreview"> <text> <span> Guests: </span> <span>  2 adults</span> </text></p>
                        
                        <p className="sd-check"> <text> Cleanliness score – 2.0   </text></p>
                        <p className="sd-check"> <text> Non Smoking  </text></p>
                        <AmbAmenitiesTabletReview  amenities={amenities}></AmbAmenitiesTabletReview>
        
 
 
                </div>
            </div>
 
         )
 
     }
}
export default FlyFinalStepPaymentReviewContainer